import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgxEditorModule } from 'ngx-editor'
import { AddressGroupComponent } from '../common/components/address-group/address-group.component'
import { ValidationModule } from '../validations/validation.module'
import { TextEditorComponent } from '../common/components/text-editor/text-editor.component'
//import { jqxDateTimeInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdatetimeinput'

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ValidationModule, NgxEditorModule],
    declarations: [
        AddressGroupComponent,
        TextEditorComponent
        //jqxDateTimeInputComponent
    ],
    exports: [
        AddressGroupComponent,
        TextEditorComponent
        //jqxDateTimeInputComponent
    ]
})
export class SharedModule {}
